import { KeepAwake } from "@capacitor-community/keep-awake"
import { App } from "@capacitor/app"
import { useIdle } from "@vueuse/core"

export const useScreensaver = () => {
  const {
    idle: isScreensaverVisible,
    reset: resetScreensaverIdle,
  } = useIdle(5 * 60 * 1000)
  const { idle: shouldSleep } = useIdle(10 * 60 * 1000)

  watch(
    () => shouldSleep.value,
    async (value) => {
      const { isSupported } = await KeepAwake.isSupported()
      if (isSupported) {
        await (value
          ? KeepAwake.allowSleep()
          : KeepAwake.keepAwake())
      }
    },
    { immediate: true }
  )

  let handler: ReturnType<typeof App.addListener>

  onMounted(() => {
    handler = App.addListener("resume", () => {
      resetScreensaverIdle()
    })
  })

  onUnmounted(() => {
    handler.remove()
  })

  return { isScreensaverVisible }
}
